import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import { useRouteLoading, LinearProgress } from 'edcom-ui';
import TopNav from '../TopNav';
import Footer from '../Footer';
import styles from './StandardLayout.module.less';

type StandardLayoutProps = React.PropsWithChildren<{
  /** Custom key to define which pages transition */
  pageKey?: string;
  /** Props to pass to TopNav */
  navProps?: React.ComponentProps<any>;
  /** Props to pass to Footer */
  footerProps?: React.ComponentProps<any>;
}>

const StandardLayout: React.FC<StandardLayoutProps> = (props) => {
  const { children, pageKey, navProps, footerProps } = props;
  const [router, loading] = useRouteLoading(false);

  return (
    <>
      {loading && <LinearProgress className={styles.loading} />}
      <TopNav {...navProps} />
      <AnimatePresence exitBeforeEnter initial={false}>
        <motion.div
          key={pageKey ?? router.route}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
      <Footer {...footerProps} />
    </>
  );
};

export default StandardLayout;
